import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../isLoading.slice';
import axios from 'axios';
import { logOut } from '../../../resources/utils';


export const eventSlice = createSlice({
    name: 'events',
    initialState: {
        events: [],
        event: {},
        message: "",
        error: "",
    },
    reducers: {
        initialStateEvent: (state, action) => {
            return {
                events: [],
                event: {},
                message: "",
                error: "",
            }
        },
        setEvents: (state, action) => {
            return {
                events: action.payload,
                event: {},
                message: "",
                error: "",
            }
        },
        setEvent: (state, action) => {
            return {
                events: [],
                event: action.payload,
                message: "",
                error: "",
            }
        },
        setEventMessages: (state, action) => {
            return {
                events: [],
                event: {},
                message: action.payload,
                error: "",
            }
        },
        setEventError: (state, action) => {
            return {
                events: [],
                event: {},
                message: "",
                error: action.payload,
            }
        },
    }
})

export const getEventsThunk = () => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/events`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setEvents(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setEventError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getEventThunk = (Event_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/events/${Event_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setEvent(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setEventError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const createEventThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.post(`/events/createEvent`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setEventMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setEventError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const createSeatThunk = (eventId, data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.post(`/createSeats/${eventId}`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setEventMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setEventError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const updateEventThunk = (Event_id, data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/events/updateEvent/${Event_id}`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setEventMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setEventError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const deleteEventThunk = (Event_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.delete(`/events/${Event_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setEventMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setEventError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const { initialStateEvent,
    setEvents,
    setEvent,
    setEventMessages,
    setEventError,
    requestchangePasswordEvent,
    changePasswordEventSuccess,
    changePasswordEventError,
    requestForgotPasswordEvent,
    ForgotPasswordEventSuccess,
    ForgotPasswordEventError } = eventSlice.actions;

export default eventSlice.reducer;